
import equiv from "./equiv.js";
export default function scrollToAnchor(anchor) {
    // //console.log('>>> scrollToAnchor')
    anchor = equiv(anchor.indexOf('#'), 0) ? anchor : `#${anchor}`;
    window.location.href = anchor;
}